/* ════════════════════════════════════════════════════════
   CréaBySana — Thème Shopify · JS
   ════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── i18n bridge (injected via window.cbsI18n in theme.liquid) ── */
  var I18N = window.cbsI18n || {};
  function t(key, fallback) { return (I18N[key] != null && I18N[key] !== '') ? I18N[key] : fallback; }

  /* ── Particles canvas (hero) ───────────────────────── */
  function initParticles() {
    var canvas = document.getElementById('cbs-particles');
    if (!canvas) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ctx = canvas.getContext('2d');
    var particles = [];
    var W, H;

    function resize() { W = canvas.width = canvas.offsetWidth; H = canvas.height = canvas.offsetHeight; }
    resize();
    window.addEventListener('resize', resize);

    var colors = ['rgba(184,150,62,', 'rgba(212,175,106,', 'rgba(240,230,200,'];
    function make() {
      return {
        x: Math.random() * W, y: H + 20,
        size: Math.random() * 3 + 1,
        speedY: -(Math.random() * 0.8 + 0.3),
        speedX: (Math.random() - 0.5) * 0.5,
        opacity: 0, maxOpacity: Math.random() * 0.4 + 0.1,
        color: colors[Math.floor(Math.random() * colors.length)],
        phase: Math.random() * Math.PI * 2
      };
    }
    for (var i = 0; i < 40; i++) { var p = make(); p.y = Math.random() * H; p.opacity = p.maxOpacity * Math.random(); particles.push(p); }

    var lastTime = 0;
    function animate(time) {
      var delta = Math.min((time - lastTime) / 16, 3); lastTime = time;
      ctx.clearRect(0, 0, W, H);
      particles.forEach(function (p, idx) {
        p.y += p.speedY * delta;
        p.x += p.speedX * delta + Math.sin(time / 2000 + p.phase) * 0.3;
        if (p.opacity < p.maxOpacity) p.opacity += 0.004 * delta;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = p.color + p.opacity + ')';
        ctx.fill();
        if (p.y < -20) particles[idx] = make();
      });
      requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);
  }

  /* ── Navbar scroll ─────────────────────────────────── */
  function initNavbar() {
    var navbar = document.getElementById('cbs-navbar');
    if (!navbar) return;
    var logo = navbar.querySelector('.nav-logo');
    var links = navbar.querySelectorAll('.nav-link');
    var hasHero = document.querySelector('.hero-bg');

    function update() {
      if (!hasHero || window.scrollY > 80) {
        navbar.classList.add('scrolled');
        if (logo) logo.style.color = 'var(--charcoal)';
        links.forEach(function (l) { l.style.color = 'var(--charcoal-soft)'; });
      } else {
        navbar.classList.remove('scrolled');
        if (logo) logo.style.color = 'white';
        links.forEach(function (l) { l.style.color = 'rgba(255,255,255,0.8)'; });
      }
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function toggleMobileMenu() {
    var menu = document.getElementById('cbs-mobile-menu');
    if (menu) menu.classList.toggle('open');
  }

  /* ── Scroll reveal ─────────────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ── Configurator ──────────────────────────────────── */
  var configState = {
    step: 1, variantId: null, productTitle: '', price: '', name: '', date: '',
    style: 'Élégant', styleLabel: t('style_elegant', 'Élégant'),
    color: 'Crème', colorLabel: t('color_cream', 'Crème')
  };

  function initConfigurator() {
    var root = document.getElementById('cbs-configurator');
    if (!root) return;

    // Product selection
    root.querySelectorAll('[data-config-product]').forEach(function (el) {
      el.addEventListener('click', function () {
        root.querySelectorAll('[data-config-product]').forEach(function (o) { o.classList.remove('selected'); });
        el.classList.add('selected');
        configState.variantId = el.getAttribute('data-variant-id');
        configState.productTitle = el.getAttribute('data-product-title') || '';
        configState.price = el.getAttribute('data-product-price') || '';
        updateRecap();
      });
    });
    // Pre-select first
    var firstProduct = root.querySelector('[data-config-product]');
    if (firstProduct) {
      firstProduct.classList.add('selected');
      configState.variantId = firstProduct.getAttribute('data-variant-id');
      configState.productTitle = firstProduct.getAttribute('data-product-title') || '';
      configState.price = firstProduct.getAttribute('data-product-price') || '';
    }

    // Style options
    root.querySelectorAll('[data-config-style]').forEach(function (el) {
      el.addEventListener('click', function () {
        root.querySelectorAll('[data-config-style]').forEach(function (o) { o.classList.remove('selected'); });
        el.classList.add('selected');
        configState.style = el.getAttribute('data-config-style');
        configState.styleLabel = el.getAttribute('data-config-style-label') || configState.style;
        updateRecap();
      });
    });

    // Color swatches
    root.querySelectorAll('[data-config-color]').forEach(function (el) {
      el.addEventListener('click', function () {
        root.querySelectorAll('[data-config-color]').forEach(function (o) { o.classList.remove('selected'); });
        el.classList.add('selected');
        configState.color = el.getAttribute('data-config-color');
        configState.colorLabel = el.getAttribute('data-config-color-label') || configState.color;
        updatePreview();
        updateRecap();
      });
    });

    // Text inputs
    var nameInput = root.querySelector('#cbs-config-name');
    var dateInput = root.querySelector('#cbs-config-date');
    if (nameInput) nameInput.addEventListener('input', function () { configState.name = nameInput.value; updatePreview(); updateRecap(); });
    if (dateInput) dateInput.addEventListener('input', function () { configState.date = dateInput.value; updatePreview(); updateRecap(); });

    // Navigation
    root.querySelectorAll('[data-config-next]').forEach(function (b) { b.addEventListener('click', function () { goStep(configState.step + 1); }); });
    root.querySelectorAll('[data-config-prev]').forEach(function (b) { b.addEventListener('click', function () { goStep(configState.step - 1); }); });

    // Add to cart
    var addBtn = root.querySelector('#cbs-config-add');
    if (addBtn) addBtn.addEventListener('click', addConfiguredToCart);
  }

  function goStep(n) {
    if (n < 1 || n > 3) return;
    configState.step = n;
    var root = document.getElementById('cbs-configurator');
    root.querySelectorAll('.config-step').forEach(function (s) { s.classList.remove('active'); });
    var active = root.querySelector('#cbs-step-' + n);
    if (active) active.classList.add('active');
    var labels = ['', t('step1_label', 'Choix du produit'), t('step2_label', 'Personnalisation'), t('step3_label', 'Finaliser')];
    var label = root.querySelector('#cbs-step-label');
    if (label) label.textContent = labels[n];
    var fill = root.querySelector('#cbs-progress-fill');
    if (fill) fill.style.width = (n / 3 * 100) + '%';
    for (var i = 1; i <= 3; i++) {
      var dot = root.querySelector('#cbs-dot-' + i);
      if (!dot) continue;
      if (i < n) { dot.style.background = '#B8963E'; dot.style.color = 'white'; dot.innerHTML = '✓'; }
      else if (i === n) { dot.style.background = '#B8963E'; dot.style.color = 'white'; dot.textContent = i; }
      else { dot.style.background = 'var(--cream-dark)'; dot.style.color = 'var(--muted)'; dot.textContent = i; }
    }
    updateRecap();
  }

  function updatePreview() {
    var nameEl = document.getElementById('cbs-preview-name');
    var dateEl = document.getElementById('cbs-preview-date');
    if (nameEl) { nameEl.textContent = configState.name || t('preview_name', 'Votre prénom'); if (configState.name) { nameEl.style.color = 'var(--charcoal)'; nameEl.style.opacity = '1'; } }
    if (dateEl) dateEl.textContent = configState.date || t('preview_date', 'votre date');
  }

  function updateRecap() {
    var empty = t('empty_value', '—');
    var map = { 'cbs-recap-product': configState.productTitle || empty, 'cbs-recap-name': configState.name || empty, 'cbs-recap-date': configState.date || empty, 'cbs-recap-style': configState.styleLabel, 'cbs-recap-color': configState.colorLabel };
    Object.keys(map).forEach(function (id) { var el = document.getElementById(id); if (el) el.textContent = map[id]; });
  }

  function addConfiguredToCart() {
    if (!configState.variantId) { showToast(t('choose_product_error', 'Veuillez choisir un produit.'), false); return; }
    var emailInput = document.getElementById('cbs-config-email');
    var qtyInput = document.getElementById('cbs-config-qty');
    var btn = document.getElementById('cbs-config-add');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    var properties = {};
    if (configState.name) properties['Prénom / Texte'] = configState.name;
    if (configState.date) properties['Date / Sous-titre'] = configState.date;
    properties['Style'] = configState.style;
    properties['Couleur'] = configState.color;
    if (emailInput && emailInput.value) properties['Email de contact'] = emailInput.value;

    if (btn) { btn.disabled = true; btn.textContent = t('submitting', 'Ajout en cours...'); }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: configState.variantId, quantity: qty, properties: properties })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || t('error_generic', 'Une erreur est survenue.')); });
      return r.json();
    })
    .then(function () {
      if (btn) { btn.disabled = false; btn.textContent = t('submit_order', 'Envoyer ma commande →'); }
      openSuccessModal();
      refreshCartCount();
    })
    .catch(function (err) {
      if (btn) { btn.disabled = false; btn.textContent = t('submit_order', 'Envoyer ma commande →'); }
      showToast(err.message || t('error_generic', 'Une erreur est survenue.'), false);
    });
  }

  /* ── Generic add-to-cart (product cards / PDP) ─────── */
  function initAddToCartForms() {
    document.querySelectorAll('form[data-cbs-cart-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        window._cbsJustAddedToCart = true;
        setTimeout(function() { window._cbsJustAddedToCart = false; }, 4000);
        e.preventDefault();

        // Reveal cart drawer by adding user-opened class
        document.documentElement.classList.add('user-opened');
        if (document.body) document.body.classList.add('user-opened');

        var btn = form.querySelector('[type="submit"]');
        var original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = t('adding', 'Ajout...'); }
        var formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: formData })
          .then(function (r) { if (!r.ok) return r.json().then(function (er) { throw new Error(er.description || t('error_generic', 'Erreur')); }); return r.json(); })
          .then(function (item) {
            if (btn) { btn.disabled = false; btn.textContent = original; }

            // Broadcast standard Shopify AJAX events & Kaching Cart triggers
            try {
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: item } }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { item: item } }));
              document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { item: item } }));
              document.dispatchEvent(new CustomEvent('kaching:cart:reload', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('kaching-cart:refresh', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('kaching-cart:open', { bubbles: true }));
            } catch(e){}

            // Direct trigger on custom web elements
            document.querySelectorAll('kaching-cart, [id*="kaching"], [class*="kaching"]').forEach(function(el) {
              el.classList.add('user-opened');
              ['refresh', 'reload', 'fetchCart', 'update', 'open', 'requestUpdate'].forEach(function(fn) {
                if (typeof el[fn] === 'function') { try { el[fn](); } catch(e){} }
              });
            });

            showToast(t('added_html', '« __TITLE__ » ajouté au panier.').replace('__TITLE__', item.product_title), true);
            refreshCartCount();
          })
          .catch(function (err) { if (btn) { btn.disabled = false; btn.textContent = original; } showToast(err.message, false); });
      });
    });
  }

  function preventAutoOpenCartDrawerOnLoad() {
    if (window._cbsJustAddedToCart) return;

    var closeDrawer = function() {
      if (window._cbsJustAddedToCart) return;
      document.body.classList.remove('cart-drawer-open', 'drawer-open', 'kaching-open');
      document.documentElement.classList.remove('cart-drawer-open', 'drawer-open', 'kaching-open');

      var selectors = [
        'kaching-cart',
        '[id*="kaching"]',
        '[class*="kaching"]',
        '.cart-drawer',
        '#cart-drawer',
        '[class*="cart-drawer"]',
        '[id*="cart-drawer"]',
        '[data-cart-drawer]'
      ];

      selectors.forEach(function(sel) {
        document.querySelectorAll(sel).forEach(function(el) {
          el.classList.remove('open', 'is-open', 'active', 'show', 'visible');
          if (el.hasAttribute('open')) el.removeAttribute('open');
          if (typeof el.close === 'function') {
            try { el.close(); } catch(e){}
          }
        });
      });
    };

    closeDrawer();
    setTimeout(closeDrawer, 100);
    setTimeout(closeDrawer, 400);
    setTimeout(closeDrawer, 1000);
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      }).catch(function () {});
  }

  /* ── Toast + modal ─────────────────────────────────── */
  function showToast(msg, success) {
    var toast = document.getElementById('cbs-toast');
    if (!toast) { toast = document.createElement('div'); toast.id = 'cbs-toast'; toast.className = 'cart-toast'; document.body.appendChild(toast); }
    toast.style.borderLeftColor = success ? 'var(--gold)' : '#C0392B';
    toast.innerHTML = '<div style="font-size:12px;color:var(--charcoal);line-height:1.5;">' + msg + '</div>' +
      (success ? '<a href="/cart" style="font-size:11px;color:var(--gold);text-transform:uppercase;letter-spacing:0.1em;font-weight:600;margin-top:8px;display:inline-block;">' + t('toast_view_cart', 'Voir le panier →') + '</a>' : '');
    toast.classList.add('show');
    clearTimeout(window._cbsToastTimer);
    window._cbsToastTimer = setTimeout(function () { toast.classList.remove('show'); }, 4000);
  }

  function openSuccessModal() {
    var modal = document.getElementById('cbs-success-modal');
    if (modal) modal.classList.add('open');
  }
  function closeModal(id) { var m = document.getElementById(id); if (m) m.classList.remove('open'); }
  window.cbsCloseModal = closeModal;
  window.cbsToggleMobileMenu = toggleMobileMenu;

  /* ── B2B quote form (sends to /contact) ────────────── */
  // Native Shopify contact form posts normally; no JS needed.

  /* ── Init ──────────────────────────────────────────── */
  function init() {
    initParticles();
    initNavbar();
    initReveal();
    initConfigurator();
    initAddToCartForms();
    preventAutoOpenCartDrawerOnLoad();
    refreshCartCount();
    // Mobile burger
    var burger = document.getElementById('cbs-burger');
    if (burger) burger.addEventListener('click', toggleMobileMenu);
    document.querySelectorAll('[data-close-mobile]').forEach(function (el) { el.addEventListener('click', function () { var m = document.getElementById('cbs-mobile-menu'); if (m) m.classList.remove('open'); }); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
